import * as React from "react";
import Dropdown from "../../Dropdown/Dropdown";
import Input from "../../Input-new/Input";
import SelectFirm from "../../SelectFirm/SelectFirm";
import SelectTeam from "../../SelectTeam-new/SelectTeam";
import UploadFiles from "./UploadFiles";
import moment from "moment";
import { priceToNumber } from "./Loan";
import { FIRMS, AGENTS } from "../../../consts/tables";
import request from 'arcdynamic-request';
import { GET_FIRM_NAME } from "../../../consts/queries";
import { executeBackendQuery } from "../../../requests/executeBackendQuery";
import { isFieldLocked } from "../../../access-levels";

const items = [{
    label: 'Seller Statement',
    name: 'SELLER_STATEMENT_FILE'
}, {
    label: 'Buyer Statement',
    name: 'BUYER_STATEMENT_FILE'
}];
const limit = 1000;

const SaleInformation = ({ ownDealsOnly, data, handleChangeInput, handleChangeDropdown, handleInputBlur, handleChangeFile, viewMode, deleted, isReferral, isFinancing, isStriveFinancing, isExtraPayment, calculateGrossAmount, locks }) => {
    const [firmNames, setFirmNames] = React.useState([]);
    const [buyerName, setBuyerName] = React.useState('');
    const [referralListSideFirm, setReferralListSideFirm] = React.useState('');
    const [referralBuyerSideFirm, setReferralBuyerSideFirm] = React.useState('');
    const [listFeeAuto, setListFeeAuto] = React.useState('');
    const [buySideFeeAuto, setBuySideFeeAuto] = React.useState('');
    const [totalClosingFeeAuto, setTotalClosingFeeAuto] = React.useState('');
    const [isLoading, setisLoading] = React.useState(false);
    const [isPrintingInvoice, setIsPrintingInvoice] = React.useState(false);
    const [outsideAgentFirmName, setOutsideAgentFirmName] = React.useState('');
    const isHsc = data.SOURCE === "HSC" || data.HSC_FINANCING;
    const todaysDate = moment(new Date()).format('dddd, MMMM D, YYYY');
    const purchasePrice = data.NEGOTIATION_PRICE ? `${(priceToNumber(data.NEGOTIATION_PRICE)).toLocaleString("en-US")}` : '0';
    const striveFEE = data.POTENTIAL_FEE ? `$${data.POTENTIAL_FEE}` : '$0';
    const formattedBuySideFee = data.BUYSIDE_FEE ? priceToNumber(data.BUYSIDE_FEE) : 0;
    const formattedListSideFee = data.LIST_FEE ? priceToNumber(data.LIST_FEE) : 0;
    const formattedStriveFee = data.POTENTIAL_FEE ? priceToNumber(data.POTENTIAL_FEE) : 0;
    const externalBroker = ((data.LISTING_AGENT_FIRM_NAME && data.LISTING_AGENT_FIRM_NAME !== "SUMMIT" && data.LISTING_AGENT_FIRM_NAME) || (buyerName !== "SUMMIT" && buyerName));
    const formattedBuyListFee = ((data.LISTING_AGENT_FIRM_NAME && data.LISTING_AGENT_FIRM_NAME !== "SUMMIT" && formattedListSideFee) || (buyerName && buyerName !== "SUMMIT" && formattedBuySideFee));
    const formattedTotalFEE = data.NEGOTIATION_PRICE ? priceToNumber(data.NEGOTIATION_PRICE) : 0;

    const buyerAgentFirmId = data.BUYER_AGENT_4_FIRM ? data.BUYER_AGENT_4_FIRM : '';
    const referralListsideFirmId = data.REFERRING_LISTING_AGENT_FIRM ? data.REFERRING_LISTING_AGENT_FIRM : '';
    const referralBuysideFirmId = data.REFERRING_BUYER_AGENT_FIRM ? data.REFERRING_BUYER_AGENT_FIRM : '';


    const imageUrl = externalBroker ? 'https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/a0983f4d8bb203d3bd2586eda88685eb439b1d7bf266341affd44276e89eba9c3256571a023076a73fc638e7fa8eb4b3b4921a2e589d287ec8c093a466596908_STRIVE_INVOICE_1.jpg'
        : 'https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/71734a21fd07667e4ebe1a7039dcbe1e72e879911d358207210a2a2ea6f6068dd386db534a58dc9bffc71561582d8f3d28931ee6ceab0af27e016b8694df631e_STRIVE_INVOICE_2.jpg'

    const referralListBuyerInvoiceImageUrl = 'https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/22525a87499bec5757ce6c0ab56ae0fdb74c84ce09c093f9e1b4fbabd94a7c100670946b256c43f5f77ee001791f58188c16643fdd95c52a59a334c65e51558b_Invoice_Listing_Buying_page-0001.jpg';
    const referralListInvoiceImageUrl = 'https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/557caeb30d25b112c6b4de7b4262b2bf5fe61da1ab7dcd09570f43e947b619d6ff6855c3e8b7cd1c6345c4397cf74883fc561b6a007f6f16c51fd730e54dd5a3_Invoice_Listing.jpg';
    const referralBuyerInvoiceImageUrl = 'https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/1b776c2db2200647525dd6e8ae95680aa11164c8a2ee19d889b6ba4bcef4eb2770045e696a4d764b4e4684186315241f5ff4c199dba76df5a2e1abff924fb040_Invoice_Buying.jpg';


    const onlyBothReferralsInvoiceImageUrl = 'https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/b44fd0ef6094d030d0766ec7ffd72b2586b509bf544247aa7d6eebed446df3fd8b7f18069a52e2ce466bd85be2ab700d2c577ace78b933a4f7473e2e00c6f3a0_STRIVE-Invoice-Both-Referrals.jpg';
    const onlyOneReferralInvoiceImageUrl = 'https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/c2f956880a80e4095721f2f10158ebc1564617e4423c56633f2e2e7da8e8d060f7c677dcf817b9510a437458d885ae02797d5ebb39f31f5141529f18eecd0298_STRIVE-Invoice-One-Referral.jpg';

    const ifReferralAgentSelected = data.REFERRING_LISTING_AGENT_FIRM || data.REFERRING_BUYER_AGENT_FIRM;

    const referralInvoiceImageUrl = (() => {
        if (data.REFERRING_LISTING_AGENT_FIRM && data.REFERRING_BUYER_AGENT_FIRM) {
            return externalBroker ? referralListBuyerInvoiceImageUrl : onlyBothReferralsInvoiceImageUrl;
        } else if (data.REFERRING_LISTING_AGENT_FIRM && !data.REFERRING_BUYER_AGENT_FIRM) {
            return externalBroker ? referralListInvoiceImageUrl : onlyOneReferralInvoiceImageUrl;
        } else if (!data.REFERRING_LISTING_AGENT_FIRM && data.REFERRING_BUYER_AGENT_FIRM) {
            return externalBroker ? referralBuyerInvoiceImageUrl : onlyOneReferralInvoiceImageUrl;
        }
        return "";
    })();

    const getClassName = (baseClass) => {
        if (data.REFERRING_LISTING_AGENT_FIRM && data.REFERRING_BUYER_AGENT_FIRM) {
            return `${baseClass}-both-referral`;
        } else if (data.REFERRING_LISTING_AGENT_FIRM || data.REFERRING_BUYER_AGENT_FIRM) {
            return `${baseClass}-one-referral`;
        }
        return baseClass;
    };
    const referralListSideContent = referralListsidePercentageOfPurchasePrice();
    const isListSideRefFirm = typeof referralListSideContent === 'string' && referralListSideContent.length >= 40;

    const referralBuySideContent = referralBuysidePercentageOfPurchasePrice();
    const isBuySideRefFirm = typeof referralBuySideContent === 'string' && referralBuySideContent.length >= 40;

    let sellerPercentage, buyerCommission = 0;
    let totalCommission = `$${(externalBroker ? (formattedStriveFee + formattedBuyListFee + priceToNumber(referralListsideCommission) + priceToNumber(referralBuysideCommission)) : (formattedStriveFee)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    let referralListsideCommission, referralBuysideCommission = 0;

    function displayBrokerFee() {
        if (data.LISTING_AGENT_FIRM_NAME && data.LISTING_AGENT_FIRM_NAME !== "SUMMIT" && formattedListSideFee) {
            return data.LIST_FEE ? `$${data.LIST_FEE}` : '$0';
        }
        if (buyerName && buyerName !== "SUMMIT" && formattedBuySideFee) {
            return data.BUYSIDE_FEE ? `$${data.BUYSIDE_FEE}` : '$0';
        }
        if (buyerCommission) {
            return `$${buyerCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        return '$0'
    }

    function externalBrokerCommission() {

        if (formattedTotalFEE && formattedBuyListFee) {
            const commissionPercent = (formattedBuyListFee / formattedTotalFEE) * 100;
            return `${externalBroker} - ${commissionPercent.toFixed(2)}% of Purchase Price`;
        }

        if (data.BUYER_AGENT_4_PERCENT) {
            // calculate outside agent percentage
            const formattedExternalPercent = parseFloat(data.BUYER_AGENT_4_PERCENT);
            const feePercentage = data.SELLER_FEE_PERCENTAGE ? parseFloat(data.SELLER_FEE_PERCENTAGE) : 0;
            sellerPercentage = ((formattedExternalPercent / 100) * (feePercentage / 100)) * 100;
            buyerCommission = (sellerPercentage / 100) * (formattedTotalFEE);
            totalCommission = `$${(externalBroker ? (formattedStriveFee + formattedBuyListFee + buyerCommission) : (formattedStriveFee)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            return `${externalBroker} - ${sellerPercentage.toFixed(2)}% of Purchase Price`;
        }
        return 0; // Return 0 or another value if there's missing data
    }
    function displayReferralListsideCommission() {
        if (data.REFERRING_LISTING_AGENT_PERCENT) {
            const purchasePrice = data.NEGOTIATION_PRICE ? priceToNumber(data.NEGOTIATION_PRICE) : 0;
            const formattedReferralListsidePercent = parseFloat(data.REFERRING_LISTING_AGENT_PERCENT);
            const feePercentage = data.SELLER_FEE_PERCENTAGE ? parseFloat(data.SELLER_FEE_PERCENTAGE) : 0;
            const totalFee = (feePercentage / 100) * purchasePrice;
            referralListsideCommission = (formattedReferralListsidePercent / 100) * totalFee;
            return `$${referralListsideCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        return 0;
    }
    function displayReferralBuyerSideCommission() {
        if (data.REFERRING_BUYER_AGENT_PERCENT) {
            const purchasePrice = data.NEGOTIATION_PRICE ? priceToNumber(data.NEGOTIATION_PRICE) : 0;
            const formattedReferralBuysidePercent = parseFloat(data.REFERRING_BUYER_AGENT_PERCENT);
            const feePercentage = data.SELLER_FEE_PERCENTAGE ? parseFloat(data.SELLER_FEE_PERCENTAGE) : 0;
            const totalFee = (feePercentage / 100) * purchasePrice;
            referralBuysideCommission = (formattedReferralBuysidePercent / 100) * totalFee;
            return `$${referralBuysideCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        return 0;
    }

    function striveFeeCommission() {
        if (formattedStriveFee && formattedTotalFEE) {
            const commissionPercent = (formattedStriveFee / formattedTotalFEE) * 100;
            return `${commissionPercent.toFixed(2)}% of Purchase Price`;
        }
        return 0;
    }
    function displayStriveFee() {
        const purchasePrice = data.NEGOTIATION_PRICE ? priceToNumber(data.NEGOTIATION_PRICE) : 0;
        const feePercentage = data.SELLER_FEE_PERCENTAGE ? parseFloat(data.SELLER_FEE_PERCENTAGE) : 0;
        const totalFee = (feePercentage / 100) * purchasePrice;
        const result = calculatePercentages(data);
        const striveFee = totalFee * (result.totalBuyerPercentage / 100) + totalFee * (result.totalListingPercentage / 100);

        return `$${striveFee.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
    function calculatePercentages(data) {
        const totalBuyerPercentage =
            (parseFloat(data.BUYER_AGENT_1_PERCENT) || 0) +
            (parseFloat(data.BUYER_AGENT_2_PERCENT) || 0) +
            (parseFloat(data.BUYER_AGENT_3_PERCENT) || 0);

        const totalListingPercentage =
            (parseFloat(data.LISTING_AGENT_1_PERCENT) || 0) +
            (parseFloat(data.LISTING_AGENT_2_PERCENT) || 0) +
            (parseFloat(data.LISTING_AGENT_3_PERCENT) || 0);

        return {
            totalBuyerPercentage,
            totalListingPercentage
        };
    }
    function referralOutsideAgentPercentageOfPurchasePrice() {
        if (!data || !data.BUYER_AGENT_4_PERCENT || !formattedStriveFee || !purchasePrice) {
            return `${externalBroker}`;
        }
        return `${externalBroker}`;
    }

    function referralListsidePercentageOfPurchasePrice() {
        if (!data || !data.REFERRING_LISTING_AGENT_PERCENT || !formattedStriveFee || !purchasePrice) {
            return `${referralListSideFirm}`;// - 0% of Purchase Price`;
        }
        const formattedReferralListSidePercent = parseFloat(data.REFERRING_LISTING_AGENT_PERCENT);
        return `${referralListSideFirm}`;// - ${formattedReferralListSidePercent.toFixed(2)}% of Purchase Price`;
    }

    function referralBuysidePercentageOfPurchasePrice() {
        if (!data || !data.REFERRING_BUYER_AGENT_PERCENT || !formattedStriveFee || !purchasePrice) {
            return `${referralBuyerSideFirm}`;// - 0% of Purchase Price`;
        }
        const formattedReferralBuysidePercent = parseFloat(data.REFERRING_BUYER_AGENT_PERCENT);
        return `${referralBuyerSideFirm}`;// - ${formattedReferralBuysidePercent.toFixed(2)}% of Purchase Price`;
    }

    function calculateCommission(percentage, striveFee) {
        if (!percentage || isNaN(percentage) || !striveFee || isNaN(striveFee)) {
            return 0;
        }
        const formattedPercentage = parseFloat(percentage).toFixed(2);
        const remainingPercentage = 100 - formattedPercentage;
        return (formattedPercentage / remainingPercentage) * striveFee;
    }

    function displayTotalCommission() {
        if (!data) return 0;

        if (data.NEGOTIATION_PRICE && data.SELLER_FEE_PERCENTAGE) {
            const purchasePrice = data.NEGOTIATION_PRICE ? priceToNumber(data.NEGOTIATION_PRICE) : 0;
            const feePercentage = data.SELLER_FEE_PERCENTAGE ? parseFloat(data.SELLER_FEE_PERCENTAGE) : 0;
            const totalFee = (feePercentage / 100) * purchasePrice;
            return `$${totalFee.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        return 0;
    }



    function printHscInvoice(event) {
        event.preventDefault();
        print();
    }
    function getAggregatedPercentage(data, keys) {
        return keys.reduce((sum, key) => {
            let value = parseFloat(data[key]) || 0;
            return sum + value;
        }, 0);
    }
    function getSummitInvoiceCommissionPercent() {
        const feePercent = parseFloat(data.SELLER_FEE_PERCENTAGE) || 0;
        const result = calculatePercentages(data);
        const agentSum = result.totalListingPercentage + result.totalBuyerPercentage;
        // If no agent split percentages are configured, the full fee goes to Summit
        if (agentSum === 0) return feePercent;
        return (feePercent * agentSum) / 100;
    }

    function getOutsideAgentInvoiceCommissionPercent() {
        const feePercent = parseFloat(data.SELLER_FEE_PERCENTAGE) || 0;
        const outsidePercents =
            (parseFloat(data.LISTING_AGENT_4_PERCENT) || 0) +
            (parseFloat(data.BUYER_AGENT_4_PERCENT) || 0);
        return (feePercent * outsidePercents) / 100;
    }

    function hasOutsideInvoiceAgent() {
        return !!(data.LISTING_AGENT_4_PERCENT || data.BUYER_AGENT_4_PERCENT);
    }


    function getOutsideInvoiceFirmName() {
        if (outsideAgentFirmName) return outsideAgentFirmName;
        if (buyerName && buyerName !== 'SUMMIT') return buyerName;
        if (data.LISTING_AGENT_FIRM_NAME && data.LISTING_AGENT_FIRM_NAME !== 'SUMMIT') return data.LISTING_AGENT_FIRM_NAME;
        return '';
    }

    function formatInvoiceCurrency(amount) {
        return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }

    function handlePrintSummitInvoice(e) {
        e.preventDefault();
        setIsPrintingInvoice(true);
        setTimeout(() => {
            // Name the printed/saved file (tab title + suggested filename) instead of the app's "iClimb" title.
            const prevTitle = document.title;
            document.title = 'Invoice & Wiring Instructions - Summit RE';
            const restoreTitle = () => {
                document.title = prevTitle;
                window.removeEventListener('afterprint', restoreTitle);
            };
            window.addEventListener('afterprint', restoreTitle);
            window.print();
            setIsPrintingInvoice(false);
        }, 100);
    }

    React.useEffect(() => {
        // fetch(0);
        fetchFirm();
        // chnage print page view to portrait
        // !important + first-in-head: the bundled PrintBooklet.scss ships a global
        // `@page { size: 11in 8.5in !important }` (landscape) that leaks into every
        // route. Among competing !important @page sizes Chromium honors the FIRST in
        // document order (see PrintContinuum.js), so this portrait rule must sit
        // before the bundle; the last-in-head copy covers spec-correct engines
        // where the last one wins.
        const css = `
        @media print {
            @page {
                size: portrait !important;
                margin: 0 !important;
            }
        }`;
        const style = document.createElement('style');
        style.innerHTML = css;
        const styleLast = document.createElement('style');
        styleLast.innerHTML = css;
        document.head.insertBefore(style, document.head.firstChild);
        document.head.appendChild(styleLast);
        const listPrice = data.SOLD_PRICE ? priceToNumber(data.SOLD_PRICE) : 0;
        const feePercentage = data.SELLER_FEE_PERCENTAGE ? parseFloat(data.SELLER_FEE_PERCENTAGE) : 0;

        const purchasePrice = data.NEGOTIATION_PRICE ? priceToNumber(data.NEGOTIATION_PRICE) : 0;
        const totalFee = (feePercentage / 100) * purchasePrice;

        const listingSideKeys = ["LISTING_AGENT_1_PERCENT", "LISTING_AGENT_2_PERCENT", "LISTING_AGENT_3_PERCENT", "LISTING_AGENT_4_PERCENT", "REFERRING_LISTING_AGENT_PERCENT"];
        const buySideKeys = ["BUYER_AGENT_1_PERCENT", "BUYER_AGENT_2_PERCENT", "BUYER_AGENT_3_PERCENT", "BUYER_AGENT_4_PERCENT", "REFERRING_BUYER_AGENT_PERCENT"];

        const aggregatedListSide = getAggregatedPercentage(data, listingSideKeys);
        const aggregatedBuySide = getAggregatedPercentage(data, buySideKeys);
        const listsideCommission = (aggregatedListSide / 100) * totalFee;
        const buysideCommission = (aggregatedBuySide / 100) * totalFee;

        setListFeeAuto(listsideCommission.toFixed(2));
        setBuySideFeeAuto(buysideCommission.toFixed(2));
        setTotalClosingFeeAuto(((listPrice * feePercentage) / 100).toFixed(2));

        return () => {
            document.head.removeChild(style);
            document.head.removeChild(styleLast);
        };
    }, [data]);

    const fetchFirm = async () => {
        try {
            const listingAgent4FirmId = data.LISTING_AGENT_4_FIRM || '';
            const [listSideResponse, buySideResponse, buyerAgentResponse, listingAgent4FirmResponse] = await Promise.all([
                executeBackendQuery({ queryName: GET_FIRM_NAME, params: { FIRM_ID: referralListsideFirmId } }),
                executeBackendQuery({ queryName: GET_FIRM_NAME, params: { FIRM_ID: referralBuysideFirmId } }),
                executeBackendQuery({ queryName: GET_FIRM_NAME, params: { FIRM_ID: buyerAgentFirmId } }),
                executeBackendQuery({ queryName: GET_FIRM_NAME, params: { FIRM_ID: listingAgent4FirmId } }),
            ]);

            if (listSideResponse.success && listSideResponse.data && listSideResponse.data.length > 0) {
                setReferralListSideFirm(listSideResponse && listSideResponse.data && listSideResponse.data[0].NAME || '');
            }

            if (buySideResponse.success && buySideResponse.data && buySideResponse.data.length > 0) {
                setReferralBuyerSideFirm(buySideResponse && buySideResponse.data && buySideResponse.data[0].NAME || '');
            }
            if (buyerAgentResponse.success && buyerAgentResponse.data && buyerAgentResponse.data.length > 0) {
                setBuyerName(buyerAgentResponse && buyerAgentResponse.data && buyerAgentResponse.data[0].NAME || '');
            }

            // Resolve outside agent firm name using direct getData (more reliable than prepared query)
            const outsideFirmId = buyerAgentFirmId || data.LISTING_AGENT_4_FIRM || '';
            const outsideAgentId = data.BUYER_AGENT_4 || data.LISTING_AGENT_4 || '';
            let resolvedFirmName = '';

            // 1. Try fetching firm name directly from FIRMS table using the firm ID on the property
            if (outsideFirmId) {
                const firmRes = await request(arc.path.api, {
                    service: 'arcimedes',
                    action: 'open.datasource.table.Data.getData',
                    params: ['code', FIRMS, {
                        limit: { count: 1, offset: 0 },
                        column: ['NAME', 'ARCIMEDES_ROW_ID'],
                        filter: [{ code: 'ARCIMEDES_ROW_ID', text: outsideFirmId, type: 'equal' }],
                        filterType: 'and',
                    }],
                });
                if (firmRes && firmRes.success && firmRes.data && firmRes.data.length > 0) {
                    const name = firmRes.data[0].NAME || '';
                    if (name && name !== 'SUMMIT') resolvedFirmName = name;
                }
            }

            // 2. If no firm on property, fetch agent record and use their FIRM
            if (!resolvedFirmName && outsideAgentId) {
                const agentRes = await request(arc.path.api, {
                    service: 'arcimedes',
                    action: 'open.datasource.table.Data.getData',
                    params: ['code', AGENTS, {
                        limit: { count: 1, offset: 0 },
                        column: ['ARCIMEDES_ROW_ID', 'FIRST_NAME', 'LAST_NAME', 'FIRM'],
                        filter: [{ code: 'ARCIMEDES_ROW_ID', text: outsideAgentId, type: 'equal' }],
                        filterType: 'and',
                    }],
                });
                if (agentRes && agentRes.success && agentRes.data && agentRes.data.length > 0) {
                    const agent = agentRes.data[0];
                    if (agent.FIRM) {
                        const firmRes2 = await request(arc.path.api, {
                            service: 'arcimedes',
                            action: 'open.datasource.table.Data.getData',
                            params: ['code', FIRMS, {
                                limit: { count: 1, offset: 0 },
                                column: ['NAME', 'ARCIMEDES_ROW_ID'],
                                filter: [{ code: 'ARCIMEDES_ROW_ID', text: agent.FIRM, type: 'equal' }],
                                filterType: 'and',
                            }],
                        });
                        if (firmRes2 && firmRes2.success && firmRes2.data && firmRes2.data.length > 0 && firmRes2.data[0].NAME) {
                            resolvedFirmName = firmRes2.data[0].NAME;
                        }
                    }
                    // Last resort: use agent's full name
                    if (!resolvedFirmName) {
                        resolvedFirmName = [agent.FIRST_NAME, agent.LAST_NAME].filter(Boolean).join(' ');
                    }
                }
            }
            setOutsideAgentFirmName(resolvedFirmName);

        } catch (error) {
            console.error("Error fetching firm names:", error);
        } finally {
            setisLoading(true);
        }
    };

    const maxLength = 49;
    const outsideAgentText = referralOutsideAgentPercentageOfPurchasePrice();
    const splitIndexOutSideAgent = outsideAgentText.length > maxLength ? outsideAgentText.slice(0, maxLength).lastIndexOf(" ") : -1;
    const firstLineOutSideAgent = splitIndexOutSideAgent > 0 ? outsideAgentText.slice(0, splitIndexOutSideAgent) : outsideAgentText.slice(0, maxLength);
    const secondLineOutSideAgent = splitIndexOutSideAgent > 0 ? outsideAgentText.slice(splitIndexOutSideAgent + 1) : outsideAgentText.slice(maxLength);


    const referralListSideText = referralListsidePercentageOfPurchasePrice();
    const splitIndexListSide = referralListSideText.length > maxLength ? referralListSideText.slice(0, maxLength).lastIndexOf(" ") : -1;
    const firstLineListSide = splitIndexListSide > 0 ? referralListSideText.slice(0, splitIndexListSide) : referralListSideText.slice(0, maxLength);
    const secondLineListSide = splitIndexListSide > 0 ? referralListSideText.slice(splitIndexListSide + 1) : referralListSideText.slice(maxLength);

    const referralBuysideText = referralBuysidePercentageOfPurchasePrice();
    const splitIndexBuySide = referralBuysideText.length > maxLength ? referralBuysideText.slice(0, maxLength).lastIndexOf(" ") : -1;
    const firstLineBuySide = splitIndexBuySide > 0 ? referralBuysideText.slice(0, splitIndexBuySide) : referralBuysideText.slice(0, maxLength);
    const secondLineBuySide = splitIndexBuySide > 0 ? referralBuysideText.slice(splitIndexBuySide + 1) : referralBuysideText.slice(maxLength);

    const invSummitPercent = getSummitInvoiceCommissionPercent();
    const invOutsidePercent = getOutsideAgentInvoiceCommissionPercent();
    const invPurchasePrice = data.NEGOTIATION_PRICE ? (priceToNumber(data.NEGOTIATION_PRICE) || 0) : 0;
    const invSummitAmount = (invPurchasePrice * invSummitPercent) / 100;
    const invOutsideAmount = (invPurchasePrice * invOutsidePercent) / 100;
    const invTotalAmount = invSummitAmount + invOutsideAmount;
    const invFormattedPrice = invPurchasePrice ? `$${invPurchasePrice.toLocaleString('en-US')}` : '';

    return (
        <React.Fragment>
            {/* Summit RE Invoice – shown only on print when isPrintingInvoice is true */}
            <div className="print-summit-invoice" style={!isPrintingInvoice ? { display: 'none' } : {}}>
                <div className="summit-invoice-header">
                    <img src={"/img/light-logo.png"} alt="Summit" className="summit-invoice-header-logo" />
                    <div className="summit-invoice-title">INVOICE</div>
                </div>
                <div className="summit-invoice-meta">
                    <p><span className="summit-invoice-date summit-invoice-highlight">{todaysDate}</span></p>
                    <p>Due Date: Upon Closing and Funding</p>
                    <p>Property: <span className="summit-invoice-highlight">{data.NAME} &ndash; {data.CITY}, {data.STATE}</span></p>
                </div>
                <table className="summit-invoice-table">
                    <thead>
                        <tr>
                            <th>Comments</th>
                            <th>Amount Due</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="purchase-row">
                            <td>Purchase Price is <span className="summit-invoice-highlight">{invFormattedPrice}</span></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;Commission &ndash; SUMMIT RE - <span className="summit-invoice-highlight">{invSummitPercent.toFixed(2)}%</span> of Purchase Price</td>
                            <td><span className="summit-invoice-highlight">{formatInvoiceCurrency(invSummitAmount)}</span></td>
                        </tr>
                        {(referralListsideFirmId && referralListsideFirmId !== '') && referralListSideFirm && (
                            <tr>
                                <td>&nbsp;&nbsp;&nbsp;Referring Listing Agent Company &ndash; <span className="summit-invoice-highlight">{referralListSideFirm}</span></td>
                                <td></td>
                            </tr>
                        )}
                        {hasOutsideInvoiceAgent() && (
                            <tr>
                                <td>&nbsp;&nbsp;&nbsp;Commission &ndash; <span className="summit-invoice-highlight">{getOutsideInvoiceFirmName()}</span> - <span className="summit-invoice-highlight">{invOutsidePercent.toFixed(2)}%</span> of Purchase Price</td>
                                <td><span className="summit-invoice-highlight">{formatInvoiceCurrency(invOutsideAmount)}</span></td>
                            </tr>
                        )}
                        {(referralBuysideFirmId && referralBuysideFirmId !== '') && buyerName && (
                            <tr>
                                <td>&nbsp;&nbsp;&nbsp;Referring Buyer Agent Company &ndash; <span className="summit-invoice-highlight">{referralBuyerSideFirm}</span></td>
                                <td></td>
                            </tr>
                        )}
                        <tr className="total-row">
                            <td>Total Commission:</td>
                            <td><span className="summit-invoice-highlight">{formatInvoiceCurrency(invTotalAmount)}</span></td>
                        </tr>
                    </tbody>
                </table>
                <div className="summit-invoice-wiring-title">WIRING INSTRUCTIONS</div>
                <table className="summit-invoice-wiring-table">
                    <tbody>
                        <tr>
                            <td>Bank:</td>
                            <td>JPMorgan Chase<br />383 Madison Ave<br />New York, NY 10017</td>
                        </tr>
                        <tr>
                            <td>Routing Number:</td>
                            <td>021000021</td>
                        </tr>
                        <tr>
                            <td>Account Number:</td>
                            <td>2906328132</td>
                        </tr>
                        <tr>
                            <td>Beneficiary:</td>
                            <td>Summit RE LLC</td>
                        </tr>
                        <tr>
                            <td>Comments:</td>
                            <td><span className="summit-invoice-highlight">{data.NAME} &ndash; {data.CITY}, {data.STATE}</span></td>
                        </tr>
                    </tbody>
                </table>
                <div className="summit-invoice-footer">
                    14755 Preston Rd Suite 440 Dallas, TX 75254
                    <br/>(972) 860-9950
                </div>
            </div>
            {
                !ifReferralAgentSelected ? (
                    <React.Fragment>
                        {/* <div className="print-Strive-Invoice" style={{ backgroundImage: `url(${imageUrl})` }}>
                            <img src={imageUrl} height={0} />
                            <div className="strive-content strive-date">{todaysDate}</div>
                            <div className="strive-content strive-property-info">{data.NAME} - {data.CITY}, {data.STATE}</div>
                            <div className="strive-content purchase-price">{purchasePrice}</div>
                            <div className="strive-content strive-commission">{striveFeeCommission()}</div>
                            <div className="strive-content strive-fee">{striveFEE}</div>
                            {
                                externalBroker ? (
                                    <React.Fragment>
                                        <div className={`strive-content strive-external-broker-firm ${externalBrokerCommission().length >= 49 ? 'broker-firm-name' : ''}`}>{externalBrokerCommission()}</div>
                                        <div className="strive-content strive-external-broker-fee">{displayBrokerFee()}</div>
                                        <div className="strive-content strive-external-total-fee">{totalCommission}</div>
                                        <div className="strive-content strive-external-comments">{data.NAME} - {data.CITY}, {data.STATE}</div>
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        <div className="strive-content strive-external-broker-fee">{totalCommission}</div>
                                        <div className="strive-content strive-comments">{data.NAME} - {data.CITY}, {data.STATE}</div>
                                    </React.Fragment>
                                )
                            }
                        </div> */}
                    </React.Fragment>) :
                    (
                        <React.Fragment>
                            <div className="print-referral-Invoice" style={isPrintingInvoice ? { display: 'none' } : { backgroundImage: `url(${referralInvoiceImageUrl})` }}>
                                <img src={referralInvoiceImageUrl} height={0} />
                                <div className="strive-content strive-date">{todaysDate}</div>
                                <div className="strive-content strive-property-info">{data.NAME} - {data.CITY}, {data.STATE}</div>
                                <div className="strive-content purchase-price">{purchasePrice}</div>
                                <div className="strive-content strive-commission">{striveFeeCommission()}</div>
                                <div className="strive-content strive-fee-with-referral">{displayStriveFee()}</div>

                                {data.REFERRING_LISTING_AGENT_FIRM && data.REFERRING_BUYER_AGENT_FIRM && externalBroker && (
                                    <React.Fragment>
                                        <div className={`strive-content listing-both-referral-with-outside-agent ${referralListSideText.length >= maxLength ? "listing-both-referral-with-outside-agent-wrap-adjusted" : ""}`}>
                                            <div>{firstLineListSide}</div>
                                            <div>{secondLineListSide}</div>
                                        </div>
                                        <div className={`strive-content listing-commission-both-referral-with-outside-agent`}>
                                            {displayReferralListsideCommission()}
                                        </div>

                                        <div className={`strive-content both-referral-with-outside-agent ${outsideAgentText.length >= maxLength ? "both-referral-with-outside-agent-wrap-adjusted" : ""}`}>
                                            <div>{firstLineOutSideAgent}</div>
                                            <div>{secondLineOutSideAgent}</div>
                                        </div>
                                        <div className={`strive-content commission-both-referral-with-outside-agent`}>
                                            {displayBrokerFee()}
                                        </div>

                                        <div className={`strive-content buying-both-referral-with-outside-agent ${referralBuysideText.length >= maxLength ? "buying-both-referral-wrap-adjusted-with-outside-agent" : ""}`}>
                                            <div>{firstLineBuySide}</div>
                                            <div>{secondLineBuySide}</div>
                                        </div>
                                        <div className={`strive-content buying-commission-both-referral-with-outside-agent`}>
                                            {displayReferralBuyerSideCommission()}
                                        </div>
                                        <div className={`strive-content both-listside-buyside-total-fee-with-outside-agent`}>
                                            {displayTotalCommission()}
                                        </div>
                                        <div className={`strive-content both-listside-buyside-comments-with-outside-agent`}>
                                            {data.NAME} - {data.CITY}, {data.STATE}
                                        </div>
                                    </React.Fragment>
                                )}
                                {data.REFERRING_LISTING_AGENT_FIRM && data.REFERRING_BUYER_AGENT_FIRM && !externalBroker && (
                                    <React.Fragment>
                                        <div className={`strive-content listing-both-referral ${referralListSideText.length >= maxLength ? "listing-both-referral-wrap-adjusted" : ""}`}>
                                            <div>{firstLineListSide}</div>
                                            <div>{secondLineListSide}</div>
                                        </div>
                                        <div className={`strive-content listing-commission-both-referral`}>
                                            {displayReferralListsideCommission()}
                                        </div>
                                        <div className={`strive-content buying-both-referral ${referralBuysideText.length >= maxLength ? "buying-both-referral-wrap-adjusted" : ""}`}>
                                            <div>{firstLineBuySide}</div>
                                            <div>{secondLineBuySide}</div>
                                        </div>
                                        <div className={`strive-content buying-commission-both-referral`}>
                                            {displayReferralBuyerSideCommission()}
                                        </div>
                                        <div className={`strive-content both-listside-buyside-total-fee`}>
                                            {displayTotalCommission()}
                                        </div>
                                        <div className={`strive-content both-listside-buyside-comments`}>
                                            {data.NAME} - {data.CITY}, {data.STATE}
                                        </div>
                                    </React.Fragment>
                                )}
                                {data.REFERRING_LISTING_AGENT_FIRM && !data.REFERRING_BUYER_AGENT_FIRM && !externalBroker && (
                                    <React.Fragment>
                                        <div className={`strive-content listing-referral ${referralListSideText.length >= maxLength ? "listing-referral-wrap-adjusted" : ""}`}>
                                            <div>{firstLineListSide}</div>
                                            <div>{secondLineListSide}</div>
                                        </div>
                                        <div className={`strive-content listing-commission-referral`}>
                                            {displayReferralListsideCommission()}
                                        </div>


                                        <div className={`strive-content listside-buyside-total-fee`}>
                                            {displayTotalCommission()}
                                        </div>
                                        <div className={`strive-content listside-buyside-comments`}>
                                            {data.NAME} - {data.CITY}, {data.STATE}
                                        </div>
                                    </React.Fragment>
                                )}
                                {!data.REFERRING_LISTING_AGENT_FIRM && data.REFERRING_BUYER_AGENT_FIRM && !externalBroker && (
                                    <React.Fragment>

                                        <div className={`strive-content buying-referral ${referralBuysideText.length >= maxLength ? "buying-referral-wrap-adjusted" : ""}`}>
                                            <div>{firstLineBuySide}</div>
                                            <div>{secondLineBuySide}</div>
                                        </div>
                                        <div className={`strive-content buying-commission-referral`}>
                                            {displayReferralBuyerSideCommission()}
                                        </div>
                                        <div className={`strive-content listside-buyside-total-fee`}>
                                            {displayTotalCommission()}
                                        </div>
                                        <div className={`strive-content listside-buyside-comments`}>
                                            {data.NAME} - {data.CITY}, {data.STATE}
                                        </div>
                                    </React.Fragment>
                                )}
                                {data.REFERRING_LISTING_AGENT_FIRM && !data.REFERRING_BUYER_AGENT_FIRM && externalBroker && (
                                    <React.Fragment>
                                        <div className={`strive-content listing-referral-firm-with-outside-agent ${referralListSideText.length >= maxLength ? "listing-referral-firm-with-outside-agent-wrap-adjusted" : ""}`}>
                                            <div>{firstLineListSide}</div>
                                            <div>{secondLineListSide}</div>
                                        </div>
                                        <div className={`strive-content listing-commission-referral-with-outside-agent`}>
                                            {displayReferralListsideCommission()}
                                        </div>
                                        <div className={`strive-content listing-referral-with-outside-agent ${outsideAgentText.length >= maxLength ? "listing-referral-with-outside-agent-wrap-adjusted" : ""}`}>
                                            <div>{firstLineOutSideAgent}</div>
                                            <div>{secondLineOutSideAgent}</div>
                                        </div>
                                        <div className={`strive-content commission-listing-referral-with-outside-agent`}>
                                            {displayBrokerFee()}
                                        </div>
                                        <div className={`strive-content listside-with-outside-agent-total-fee`}>
                                            {displayTotalCommission()}
                                        </div>
                                        <div className={`strive-content listside-buyside-comments-with-outside-agent`}>
                                            {data.NAME} - {data.CITY}, {data.STATE}
                                        </div>
                                    </React.Fragment>
                                )}
                                {!data.REFERRING_LISTING_AGENT_FIRM && data.REFERRING_BUYER_AGENT_FIRM && externalBroker && (
                                    <React.Fragment>
                                        <div className={`strive-content buying-referral-with-outside-agent ${outsideAgentText.length >= maxLength ? "buying-referral-with-outside-agent-wrap-adjusted" : ""}`}>
                                            <div>{firstLineOutSideAgent}</div>
                                            <div>{secondLineOutSideAgent}</div>
                                        </div>
                                        <div className={`strive-content commission-buying-referral-with-outside-agent`}>
                                            {displayBrokerFee()}
                                        </div>
                                        <div className={`strive-content buying-referral-firm-with-outside-agent ${referralBuysideText.length >= maxLength ? "buying-referral-firm-with-outside-agent-wrap-adjusted" : ""}`}>
                                            <div>{firstLineBuySide}</div>
                                            <div>{secondLineBuySide}</div>
                                        </div>
                                        <div className={`strive-content buying-commission-referral-with-outside-agent`}>
                                            {displayReferralBuyerSideCommission()}
                                        </div>
                                        <div className={`strive-content buyside-referral-with-outside-agent-total-fee`}>
                                            {displayTotalCommission()}
                                        </div>
                                        <div className={`strive-content buyside-referral-with-outside-agent-comments`}>
                                            {data.NAME} - {data.CITY}, {data.STATE}
                                        </div>
                                    </React.Fragment>
                                )}



                            </div>
                        </React.Fragment>
                    )}

            <div className="Sale-information">
                <div className="Sale-information_column">
                    <Input
                        className="Sale-information_column_item"
                        placeholder="MM/DD/YYYY HH:MM"
                        type="datetime-local"
                        valueType="datetime"
                        name="CLOSE_OF_ESCROW"
                        label="Close Of Escrow"
                        value={data.CLOSE_OF_ESCROW}
                        disabled={isFieldLocked(locks, "CLOSE_OF_ESCROW")}
                        handleParentChange={handleChangeInput}
                        handleParentBlur={isHsc ? handleInputBlur : null}
                        viewMode={viewMode}
                        deleted={deleted}
                        required={ownDealsOnly && data.SOURCE == 'External' && data.STATUS == 'Closed' ? true : null} />
                    {isExtraPayment && <div>
                        <SelectTeam
                            className="Sale-information_column_item"
                            isFromProperty
                            value={data.LISTING_AGENT_1}
                            valueKey="LISTING_AGENT_1"
                            label="Agent"
                            data={data}
                            handleParentChange={handleChangeDropdown}
                            viewMode={viewMode}
                            deleted={deleted} />
                        <Input
                            className="Sale-information_column_item"
                            type="text"
                            valueType="float"
                            name="REFERRAL_FEE"
                            label="Fee Amount"
                            value={data.REFERRAL_FEE}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            decimals={2}
                            isDollar
                            disabled />

                        <Input
                            className="Sale-information_column_item"
                            type="text"
                            valueType="float"
                            name="NET_FEE"
                            label="Net Amount"
                            value={data.NET_FEE}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            decimals={2}
                            isDollar />
                        <button className="button-new positive" type='button' onClick={calculateGrossAmount} viewMode={viewMode}>
                            Calculate Fee Amount
                        </button>


                    </div>}
                    {(isReferral) ?
                        <React.Fragment>
                            <SelectTeam
                                className="Sale-information_column_item"
                                isFromProperty
                                value={data.LISTING_AGENT_1}
                                valueKey="LISTING_AGENT_1"
                                percentKey="LISTING_AGENT_1_PERCENT"
                                percentDisabled={isFieldLocked(locks, "LISTING_AGENT_1_PERCENT")}
                                label="Referal Agent 1"
                                data={data}
                                hasAgentPercent={true}
                                handleParentChange={handleChangeDropdown}
                                handleInputParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                onlySummitAgents />
                            <SelectTeam
                                className="Sale-information_column_item"
                                isFromProperty
                                value={data.LISTING_AGENT_2}
                                valueKey="LISTING_AGENT_2"
                                percentKey="LISTING_AGENT_2_PERCENT"
                                percentDisabled={isFieldLocked(locks, "LISTING_AGENT_2_PERCENT")}
                                label="Referal Agent 2"
                                data={data}
                                hasAgentPercent={true}
                                handleParentChange={handleChangeDropdown}
                                handleInputParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                onlySummitAgents />
                            <Input
                                className="Sale-information_column_item"
                                type="text"
                                valueType="float"
                                name="REFERRAL_FEE"
                                label="Fee Amount"
                                value={data.REFERRAL_FEE}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2}
                                isDollar />
                            <SelectFirm
                                className="Sale-information_column_item"
                                value={data.REFERRED_BY_ID}
                                valueKey='REFERRED_BY_ID'
                                label='Referred By'
                                data={data}
                                handleParentChange={handleChangeDropdown}
                                viewMode={viewMode}
                                deleted={deleted} />
                            <Dropdown
                                className="Sale-information_column_item"
                                data={data}
                                optionsType="referralType"
                                value={data.REFERRAL_TYPE}
                                valueKey="REFERRAL_TYPE"
                                label="Referral Type"
                                handleParentChange={handleChangeDropdown}
                                viewMode={viewMode}
                                deleted={deleted} />
                        </React.Fragment>

                        : !isExtraPayment && <div>
                            <React.Fragment>
                                <div className="estimated-price-container">
                                    <Input
                                        className="Sale-information_column_item estimated-price"
                                        type="text"
                                        valueType="integer"
                                        name="SOLD_PRICE"
                                        label="Price @ Close"
                                        value={data.SOLD_PRICE}
                                        disabled={isFieldLocked(locks, "SOLD_PRICE")}
                                        handleParentChange={handleChangeInput}
                                        viewMode={viewMode}
                                        deleted={deleted}
                                        isDollar />
                                    <Dropdown
                                        className="Sale-information_column_item estimated-price-type"
                                        type="text"
                                        valueType="text"
                                        data={data}
                                        optionsType="estimatedPrice"
                                        value={data.ESTIMATED_PRICE_TYPE}
                                        valueKey="ESTIMATED_PRICE_TYPE"
                                        label="Type"
                                        handleParentChange={handleChangeDropdown}
                                        viewMode={viewMode}
                                        deleted={deleted}
                                        disabled={isFieldLocked(locks, "ESTIMATED_PRICE_TYPE")} />
                                </div>
                                {/* Allowing user to add  Cap Rate for external properties as they dont have data*/}
                                {data.SOURCE === "External" ? <Input
                                    className="Sale-information_column_item"
                                    type="text"
                                    valueType="percent"
                                    name="CLOSE_CAP_RATE"
                                    label="Cap Rate @ Close - auto"
                                    value={data.CLOSE_CAP_RATE}
                                    handleParentChange={handleChangeInput}
                                    viewMode={viewMode}
                                    deleted={deleted}
                                    disabled={isFieldLocked(locks, "CLOSE_CAP_RATE")} /> :
                                    <Input
                                        className="Sale-information_column_item"
                                        type="text"
                                        valueType="percent"
                                        name="CLOSE_CAP_RATE"
                                        label="Cap Rate @ Close - auto"
                                        value={data.CLOSE_CAP_RATE}
                                        handleParentChange={handleChangeInput}
                                        viewMode={viewMode}
                                        deleted={deleted}
                                        disabled />}
                                <Input
                                    className="Sale-information_column_item"
                                    type="text"
                                    valueType="integer"
                                    name="CLOSE_NOI"
                                    label="NOI @ Close"
                                    value={data.CLOSE_NOI}
                                    disabled={isFieldLocked(locks, "CLOSE_NOI")}
                                    handleParentChange={handleChangeInput}
                                    viewMode={viewMode}
                                    deleted={deleted}
                                    isDollar />
                                <Input
                                    className="Sale-information_column_item"
                                    type="text"
                                    valueType="float"
                                    name="CLOSE_PRICE_PER_SQFT"
                                    label="PSF @ Close – auto"
                                    value={data.CLOSE_PRICE_PER_SQFT}
                                    disabled
                                    handleParentChange={handleChangeInput}
                                    viewMode={viewMode}
                                    deleted={deleted}
                                    decimals={2}
                                    isDollar />
                                {(isFinancing || isStriveFinancing) &&
                                    <Input
                                        className="Sale-information_column_item"
                                        type="text"
                                        valueType="integer"
                                        name="DOWN_PAYMENT"
                                        label="Down Payment"
                                        value={data.DOWN_PAYMENT}
                                        disabled
                                        handleParentChange={handleChangeInput}
                                        viewMode={viewMode}
                                        deleted={deleted}
                                        isDollar />}
                                {isFinancing &&
                                    <Input
                                        className="Sale-information_column_item"
                                        type="text"
                                        valueType="integer"
                                        name="LOAN_AMOUNT"
                                        label="Loan Amount"
                                        value={data.LOAN_AMOUNT}
                                        disabled
                                        handleParentChange={handleChangeInput}
                                        viewMode={viewMode}
                                        deleted={deleted}
                                        isDollar />}
                            </React.Fragment></div>}
                </div>
                {!isReferral && !isFinancing && !isExtraPayment && <div className="Sale-information_column">
                    <div className="Sale-information_column_closing_fee">
                        <div className="input-item">
                            <Input
                                type="text"
                                valueType="float"
                                name="TOTAL_CLOSING_FEE_AUTO"
                                label="Total Closing Fee - Auto"
                                value={totalClosingFeeAuto}
                                disabled
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2}
                                isDollar
                            />
                        </div>
                        <div className="input-item">
                            <Input
                                type="text"
                                valueType="percent"
                                label="Fee Percentage"
                                name="SELLER_FEE_PERCENTAGE"
                                value={data.SELLER_FEE_PERCENTAGE}
                                disabled
                                viewMode={viewMode}
                                deleted={deleted}
                            />
                        </div>
                    </div>

                    <Input
                        className="Sale-information_column_item"
                        type="text"
                        valueType="float"
                        name="LIST_FEE"
                        label="List Fee - auto"
                        value={listFeeAuto}
                        disabled
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        decimals={2}
                        isDollar />
                    <Input
                        className="Sale-information_column_item"
                        type="text"
                        valueType="float"
                        name="BUYSIDE_FEE"
                        label="Buyside Fee - auto"
                        value={buySideFeeAuto}
                        disabled
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        decimals={2}
                        isDollar />
                    <Input
                        className="Sale-information_column_item"
                        type="text"
                        valueType="float"
                        name="POTENTIAL_FEE"
                        label="SUMMIT Fee - Auto"
                        value={data.POTENTIAL_FEE}
                        disabled
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        decimals={2}
                        isDollar />
                    <UploadFiles
                        classNames="Sale-information_column_item"
                        data={data}
                        viewMode={viewMode}
                        deleted={deleted}
                        handleChangeFile={handleChangeFile}
                        initialFilesAmount={2}
                        maxFilesAmount={items.length}
                        items={items}
                        disabled={ownDealsOnly} />
                    <div>
                        <button className="button-new" onClick={handlePrintSummitInvoice} style={{ border: '1px solid #90B9ED', color: '#90B9ED', background: 'transparent', width: 'auto', padding: '0 16px' }}>INVOICE &amp; WIRING INSTRUCTIONS</button>
                    </div>
                </div>}
            </div>
        </React.Fragment>
    );
};

export default SaleInformation;
